import { render, staticRenderFns } from "./OpenCloseIssues.vue?vue&type=template&id=1f0dde5c&scoped=true&"
import script from "./OpenCloseIssues.vue?vue&type=script&lang=js&"
export * from "./OpenCloseIssues.vue?vue&type=script&lang=js&"
import style0 from "./OpenCloseIssues.vue?vue&type=style&index=0&id=1f0dde5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0dde5c",
  null
  
)

export default component.exports